// Builds the dropdown options for NCPDP / member pharmacy pickers from the
// api/UserProgram/GetUserLocationsDetails payload (UserProgramRecordLocation).
//
// Every option carries the RPID of the parent company the member pharmacy belongs to, so a
// screen can tell which parent company a selected pharmacy sits under without a second lookup.
// The GetUserLocations endpoint cannot back these pickers: it returns an MMID -> "Name (NCPDP)"
// dictionary that drops the RPID entirely.
//
// Options are sorted by member name so the pickers keep the alphabetical order the server
// applied when they were fed from GetUserLocations.

function ToLocationList(locationDetails) {
  return Array.isArray(locationDetails) ? locationDetails : [];
}

function ByMemberName(firstLocation, secondLocation) {
  const firstName = firstLocation.memberName || "";
  const secondName = secondLocation.memberName || "";

  return firstName.localeCompare(secondName);
}

export function ToLocationLabel(location) {
  return location.memberName + " (" + location.memberNcpdp + ")";
}

function ToOption(location, label, value) {
  return {
    label: label,
    value: value,
    ncpdp: location.memberNcpdp,
    mmid: location.memberMmid,
    rpid: location.memberRpid,
    parentCompanyName: location.parentCompanyName,
  };
}

// "Member Name (NCPDP)" labels keyed by MMID - the shape the layout and most pickers use.
// The MMID is kept as a string because these options previously came from an MMID-keyed
// dictionary, so every consumer has been comparing and sending string values. The raw numeric
// MMID is still available on the mmid property.
export function ToLocationOptions(locationDetails) {
  return ToLocationList(locationDetails)
    .slice()
    .sort(ByMemberName)
    .map((location) =>
      ToOption(location, ToLocationLabel(location), String(location.memberMmid))
    );
}

// "Member Name (NCPDP)" labels keyed by NCPDP, for pickers whose selection is an NCPDP.
export function ToNcpdpOptions(locationDetails) {
  return ToLocationList(locationDetails)
    .slice()
    .sort(ByMemberName)
    .map((location) =>
      ToOption(location, ToLocationLabel(location), location.memberNcpdp)
    );
}

// Bare NCPDP labels keyed by NCPDP, for pickers that show the NCPDP on its own.
export function ToNcpdpCodeOptions(locationDetails) {
  return ToLocationList(locationDetails)
    .slice()
    .sort(ByMemberName)
    .map((location) =>
      ToOption(location, location.memberNcpdp, location.memberNcpdp)
    );
}
